// Real OperatorAI social URLs
export const SOCIALS = [
  {
    key: "instagram",
    name: "Instagram",
    handle: "@theoperatoraihq",
    url: "https://instagram.com/theoperatoraihq",
  },
  {
    key: "youtube",
    name: "YouTube",
    handle: "@theoperatoraihq",
    url: "https://youtube.com/@theoperatoraihq",
  },
  {
    key: "facebook",
    name: "Facebook",
    handle: "theoperatoraihq",
    url: "https://facebook.com/theoperatoraihq",
  },
  {
    key: "tiktok",
    name: "TikTok",
    handle: "@theoperatoraihq",
    url: "https://tiktok.com/@theoperatoraihq",
  },
];

export const CONTACT_EMAIL = "hello@operatoraihq.com";
